export default {
    USERS: 'users',
    DELIVERY_SETTINGS: 'deliverySettings',
    PROMOTIONS: 'promotions',
    CANTEENS: 'canteens',
    COMPANIES: 'companies',
    COMPANY_ADDRESSES: 'companyAddresses',
    COMPANY_ALLOWANCES: 'companyAllowances',
    COMPANY_ALLOWED_MEALS: 'companyAllowedMeals',
    COMPANY_BALANCES: 'companyBalances',
    COMPANY_INVOICE: 'companyInvoice',
    COMPANY_CLOUDCANTEENS: 'companyCloudcanteens',
    COMPANY_TEAMS: 'companyTeams',
    COMPANY_DELIVERY_RULE: 'deliveryRule',
    USER_ADDRESSES: 'userAddresses',
    ORDERS: 'orders',
    ORDERS_PUBLIC: 'ordersPublic',
    RESTAURANT_ORDER_CANTEENS: 'restaurantOrderCanteens',
    RESTAURANTS: 'restaurants',
    MEAL_CATEGORIES: 'mealCategories',
    MEAL_OPTION_GROUP: 'mealOptionGroups',
    MEAL_OPTION: 'mealOptions',
    MEAL: 'meals',
    NOTIFICATION: 'notification',
    TRANSLATIONS: 'translations',
    TAGS: 'tags',
    TAG_GROUPS: 'tagGroups',
    DELIVERIES: 'deliveries',
    RESIDENTIAL_CANTEENS: 'residentialCanteens',
    RESIDENTIAL_CANTEEN_ADDRESSES: 'residentialCanteenAddresses',
    RESIDENTIAL_CANTEEN_RELATIONS: 'residentialCanteenRelations',
    AUDITLOG: 'auditlog',
    CUSTOM_EXPORT: 'customExport',
    CUSTOM_EXPORT_CATEGORY: 'customExportCategory',
    COUPONS: 'coupons',
    INVOICES: 'invoices',
    SETTINGS: 'settings',
    REGISTRATION_CODES: 'registrationCodes',
    PROMO_BANNERS: 'promoBanners',
    TODOS: 'todos',
    BRANDS: 'brands',
    ORDER_HISTORY: 'orderHistory',
    TABLET_AUTO_LOGIN: 'tabletAutoLogin',
}
